import React from 'react';
import Reflux from 'reflux';
import Header from '../sections/Header';
import AppStore from '../AppStore';
import ProfileStore from '../stores/ProfileStore';
import ProfileActions from '../actions/ProfileActions';
import Profile from '../sections/Profile';
import TopList from '../sections/TopList';
import UserList from '../sections/UserList';
import FavList from '../sections/TopicList';
import Footer from '../sections/Footer';
import RcIf from 'rc-if';

class ProfilePage extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            username: props.username
        };
        this.stores = [AppStore, ProfileStore];
    }

    componentDidMount () {
        ProfileActions.getProfile(this.props.username);
    }

    componentWillReceiveProps (nextProps) {
        if (this.state.username !== nextProps.username) {
            this.setState({username: nextProps.username});
            ProfileActions.getProfile(nextProps.username);
        }
    }

    loadMoreProfileTops = () => {
        ProfileActions.getMoreProfileTopics();
    }

    render () {
        return (
          <div>
            <Header />
            <main>
              {
                this.state.userData && this.state.profile
                  ? <Profile
                    profile={this.state.profile}
                    topsCount={this.state.topsCount}
                    owner={this.state.userData.username === this.state.profile.username} />
                  : <div>loading</div>
              }
              <div className='container-gral'>
                <RcIf if={!this.props.section}>
                  <div className='action-profile'>
                    <h5 className='title-home top-profile'>Tops</h5>
                  </div>
                  <TopList tops={this.state.userTopics} />
                  <RcIf if={this.state.userTopics.length < this.state.topsCount}>
                    <div className='row center-align'>
                      <a className='btn-flat waves-effect waves-light plus-btn' onClick={this.loadMoreProfileTops}>
                        <img src='/images/icons/plus.svg' />
                      </a>
                    </div>
                  </RcIf>
                </RcIf>
                <RcIf if={this.props.section === 'followers'}>
                  <div className='action-profile'>
                    <h5 className='title-home top-profile'>Seguidores</h5>
                  </div>
                  {this.state.profile && <UserList type='followers' users={this.state.profile.followers} />}
                </RcIf>
                <RcIf if={this.props.section === 'following'}>
                  <div className='action-profile'>
                    <h5 className='title-home top-profile'>Seguidos</h5>
                  </div>
                  {this.state.profile && <UserList type='following' users={this.state.profile.following} />}
                </RcIf>
                <RcIf if={this.props.section === 'favourites'}>
                  <div className='action-profile'>
                    <h5 className='title-home top-profile'>Favoritos</h5>
                  </div>
                  {this.state.profile && <FavList topics={this.state.userFavs} noResultsMessage='Aún no tiene ningún favorito' />}
                </RcIf>
              </div>
            </main>
            <Footer />
          </div>
        );
    }
}

export default ProfilePage;



// WEBPACK FOOTER //
// ./src/pages/ProfilePage.js